const skills = [
  {
    id: 1,
    name: "HTML5",
    img: require("../images/skills/html5.svg"),
  },
  {
    id: 2,
    name: "CSS3",
    img: require("../images/skills/css3.svg"),
  },
  {
    id: 3,
    name: "SASS",
    img: require("../images/skills/sass.png"),
  },
  {
    id: 4,
    name: "Grid-Flexbox",
    img: require("../images/skills/grid-flexbox.png"),
  },
  {
    id: 5,
    name: "Diseño Responsive",
    img: require("../images/skills/responsive-design.png"),
  },
  {
    id: 6,
    name: "JavaScript",
    img: require("../images/skills/javascript.png"),
  },
  {
    id: 7,
    name: "ES6",
    img: require("../images/skills/es6.png"),
  },
  {
    id: 8,
    name: "Bootstrap",
    img: require("../images/skills/bootstrap.png"),
    
  },
  {
    id: 9,
    name: "React",
    img: require("../images/skills/react.png"),
  },
  {
    id: 10,
    name: "API REST",
    img: require("../images/skills/restapi.png"),
  },
  {
    id: 11,
    name: "Gulp",
    img: require("../images/skills/gulp.svg"),
  },
  {
    id: 12,
    name: "Git",
    img: require("../images/skills/git.png"),
  },
  {
    id: 13,
    name: "GitHub",
    img: require("../images/contacts/github.svg"),
  },
  {
    id: 14,
    name: "BitBucket",
    img: require("../images/skills/bitbucket.png"),
  },
  {
    id: 15,
    name: "Sketch",
    img: require("../images/skills/sketch.png"),
  },
  {
    id: 16,
    name: "Zeplin",
    img: require("../images/skills/zeplin.png"),
  },
  {
    id: 17,
    name: "Photoshop",
    img: require("../images/skills/photoshop.png"),
  },
  {
    id: 18,
    name: "Agile-Scrum",
    img: require("../images/skills/agile-scrum.png"),
  },
  {
    id: 19,
    name: "Trello",
    img: require("../images/skills/trello.svg"),
  },
  {
    id: 20,
    name: "VSCode",
    img: require("../images/skills/vscode.svg"),
  },
];

export default skills;
